<template>
    <eleicoes-deputados-eleitos v-if="$state.view == 'deputados-eleitos'"/>
    <eleicoes-possiveis-acordos v-else-if="$state.view == 'possiveis-acordos'"/>
    <div v-else-if="$state.lite">
        <main>
            <eleicoes-deputados-eleitos/>
            <eleicoes-resultados-lite/>
        </main>
    </div>
    <div v-else>
        <triggers 
            :items="regions" 
            :value="tab" 
            @select="select" 
            :data-kpi="$kpis(`tabs`)"
        />
        <main>
            <section>
                <template v-if="tab == 0">
                    <eleicoes-deputados-eleitos/>
                    <div class="desktop">
                        <eleicoes-possiveis-acordos/>
                        <eleicoes-composicao-parlamento/>
                    </div>
                </template>
                <mapa v-if="tab == 1"/>
                <locais v-if="tab == 2" estrangeiro/>
            </section>
            <section>
                <h3 v-if="subtitle">{{subtitle}}</h3>
                <h2 v-if="title">{{title}}</h2>
                <eleicoes-resultados/>
                <!-- <eleicoes-resultados :selectable="tab == 1"/> -->
                <eleicoes-copyrights/>
            </section>
        </main>
    </div>
</template>

<script>
import { locals } from '@/core/map'
import { tipo } from '@/widgets/mapa/utils'

export default {
    data: () => ({
        regions: [
            { code: '990000', title: 'Global' },
            { code: '500000', title: 'Nacional' },
            { code: '600000', title: 'Estrangeiro' }
        ]
    }),
    beforeMount() {
        if(!this.$state.local) this.$state.local = (!this.$state.lite ? this.$query.local : null) || '990000';
    },
    methods: {
        select(region) {
            if(!region || !region.code) return;
            this.$state.local = region.code;
        }
    },
    computed: {
        root() {
            let root;
            this.regions.forEach(item => {
                if(item.code == this.$state.local) root = true;
            })
            return root;
        },
        tab() {
            const local = parseInt(`${this.$state.local || '99'}`.substr(0, 2));
            return local != 99 ? (local <= 50 ? 1 : 2) : 0;
        },
        title() {
            if(!this.$state.local && !this.$state.data) return;
            let title = (!this.$state.data ? null : this.$state.data.nome_do_territorio) || (!locals || !locals[this.$state.local] ? null : locals[this.$state.local].title);
            if(this.$state.partido && title) title += ` - ${this.$state.partido}`
            return title || (this.$state.local != '990000' ? null : 'Global');
        },
        subtitle() {
            return !this.root ? tipo(this.$state.local) : null;
        }
    }
}
</script>
<style scoped lang="scss">
@import '@/styles/mixins.scss';
@import '@/styles/variables.scss';
section{
	margin-top: 1rem;
}
</style>